import React from 'react';
import logo from "../assets/logo.png";
import {Link} from "react-router";

function Header() {
    return (
        <header className="header-bottom" id="header">
            <div className="container-fluid header-bottom__style-two">
                <nav className="navbar navbar-header__style-two navbar-expand-lg navbar-light">
                    <Link className="navbar-brand logo" to="/" reloadDocument={true}>
                        <img src={logo} alt="header"/>
                    </Link>
                    <button
                        className="navbar-toggler header-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
        <span id="hiddenNav">
          <i className="las la-bars" style={{color:"#0a0a0a"}}/>
        </span>
                    </button>
                    <div className="signup-button d-lg-block d-none">
                        <Link to="/giris" className="btn--base header__style-two" style={{color: 'white'}} reloadDocument>
                            YAPAY ZEKA DEMO GİRİŞİ
                        </Link>
                    </div>

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav nav-menu style-two">
                            <li className="nav-item">
                                <Link
                                    className="nav-link style-two"
                                    aria-current="page"
                                    to="/"
                                    reloadDocument
                                >
                                    Ana Sayfa{" "}
                                    <span className="nav-item__icon-microphone">
                <span className="icon-mic-1"/>
              </span>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    className="nav-link style-two"
                                    aria-current="page"
                                    to="/hakkimizda"
                                    reloadDocument
                                >
                                    Hakkımızda{" "}
                                    <span className="nav-item__icon-microphone">
                <span className="icon-mic-1"/>
              </span>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    className="nav-link style-two"
                                    aria-current="page"
                                    to="/dijital-network"
                                    reloadDocument
                                >
                                    Dijital Network{" "}
                                    <span className="nav-item__icon-microphone">
                <span className="icon-mic-1"/>
              </span>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    className="nav-link style-two"
                                    aria-current="page"
                                    to="/hedefleme-seceneklerimiz"
                                    reloadDocument
                                >
                                    Hedefleme Seçeneklerimiz{" "}
                                    <span className="nav-item__icon-microphone">
                <span className="icon-mic-1"/>
              </span>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    className="nav-link style-two"
                                    aria-current="page"
                                    to="/iletisime-gecin"
                                    reloadDocument
                                >
                                    İletişime Geçin{" "}
                                    <span className="nav-item__icon-microphone">
                <span className="icon-mic-1"/>
              </span>
                                </Link>
                            </li>

                        </ul>
                    </div>
                </nav>
            </div>
        </header>

    );
}

export default Header;